import { TClassState } from '@/redux/reducers/class';
import { TAddPlayerToClassSuccess } from '@/redux/actions/class';

export const addPlayerToClassUpdateState = (state: TClassState, action: TAddPlayerToClassSuccess): TClassState => ({
  ...state,
  addPlayerToClassResponse: action.payload.response,
});
